import React, { useState, useEffect } from 'react';
import { message, Form, Popover, Table } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import moment from 'moment';//日期格式化导包
import { studentCheckLogin } from '../newMain/studentMain';
import StudentSeeAllJobApplicationsSort from './studentSeeAllJobApplicationsSort';
import context from '../../public/js/context';

import './studentSeeAllJobApplications.css';

import searchImg from '../../public/img/newMain/Search.png';
import sortImg from '../../public/img/newMain/Sort.png';
import resetImg from '../../public/img/newMain/Reset.png';

const StudentSeeAllJobApplications = (props) => {
    const history = useHistory();
    const { showStatus } = useParams();
    const [tablesCount, setTablesCount] = useState(0);
    const [tables, setTables] = useState([]);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [jobPostModel, setJobPostModel] = useState({});
    const [form] = Form.useForm();
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [jobSortPostModel, setJobSortPostModel] = useState({});
    const [isReset, setIsReset] = useState(false);

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        search(pageSize, 1);
    }, []);

    const search = (pageSizeNew, current, flag, jobModel) => {
        let model = {}
        if (jobSortPostModel) {
            model = { ...jobSortPostModel }
        }
        if (jobModel) {
            model = { ...jobModel }
        }
        model.jobTitle = flag ? '' : jobPostModel.jobTitle
        model.statusTypeList = ['APPLY', 'OFFER_REPLY']
        model.studentModuleId = Config.studentInfo?.studentId
        model.pageSize = pageSizeNew
        model.startRow = (current - 1) * pageSizeNew
        model.page = current
        if (showStatus === 'rejected') {
            model.jobApplStatusList = ['REJECTED']
        } else if (showStatus === 'special') {
            model.jobApplStatusList = ['SPECIAL_ARRANGEMENT']
        } else if (showStatus === 'request') {
            model.jobApplStatusList = ['REQUEST_DOCUMENT']
        } else if (showStatus === 'offer') {
            model.jobApplStatusList = ['OFFER']
        }
        Base.callBackApi("jobAppl/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                message.error(data?.msg)
            }
        })
    }

    const reset = () => {
        setJobPostModel({});
        setJobSortPostModel({})
        form.resetFields()
        setIsReset(true)
        search(10, 1, true, {});
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew);
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1);
    }

    const modelChange = (key, value) => {
        setJobPostModel(model => {
            return { ...model, ...{ [key]: value } };
        });
        search(pageSize, 1);
    }

    const jump = (path) => {
        history.push(path);
    }

    const handleOpenChange = (newOpen) => {
        setPopoverVisible(newOpen);
    };

    const handleOpenChange2 = (newOpen, status, jobSortJobPostModel) => {
        if (status) {
            setJobSortPostModel(jobSortJobPostModel)
            search(pageSize, 1, false, jobSortJobPostModel)
        }
        setIsReset(false)
        setPopoverVisible(newOpen);
    };
    const tableColumns = {
        jobId: "job_id",
        jobTitle: "job_title",
        progTitle: "prog_title",
        companyName: "company_name",
        applyDate: "apply_date",
        jobApplStatus: "job_appl_status",
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!jobSortPostModel.orderBy) {
            if (orderBy !== jobSortPostModel.orderBy) {
                jobSortPostModel.orderBy = orderBy;
                search(10, 1)
            }
        }
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Job ID',
            dataIndex: 'jobId',
            className: 'tableWidth11',
            render: text => text ? '#' + text : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobId') },
        },
        {
            title: 'Job Title',
            dataIndex: 'jobTitle',
            className: 'tableWidth26',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
        },
        {
            title: 'THEi Programme',
            dataIndex: 'progTitle',
            className: 'tableWidth29',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableProgrammeBox'>{text}</div>
                </Popover>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progTitle') },
        },
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            className: 'tableWidth19',
            render: (text, record) => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableProgrammeBox'>{text}</div>
                </Popover>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyName') },
        },
        {
            title: 'Application Date',
            dataIndex: 'applyDate',
            className: 'tableWidth15',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'applyDate') },
        },
        {
            title: 'Status',
            dataIndex: 'jobApplStatus',
            width: 180,
            render: text => (
                <div className='tableStatusBox'>
                    {context.jobApplStatusMap.map(item => item.value === text && <div className={'tableStatus ' + item.value}>
                        {item.label}
                    </div>)}
                </div>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobApplStatus') },
        },
        {
            title: 'Action',
            dataIndex: 'jobApplId',
            fixed: 'right',
            width: 80,
            render: text => (
                <div className='tableAction'>
                    <div className='tableActionExport' onClick={() => jump('/student/studentApplyJobDetail/' + text)}></div>
                </div>
            )
        },
    ];
    /*eslint-disable*/

    return (
        <div id="container" className='websiteTemplate studentSeeAllJobApplications'>
            <div className='homeTitle'>All Job Applications</div>
            <div className='websiteSysSearchRow'>
                <div className='websiteSysSearchBar'>
                    <input style={{ paddingLeft: '11px' }} placeholder="Search By job title or by job ID"
                        value={jobPostModel?.jobTitle || ''}
                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1) : null}
                        onChange={(e) => modelChange("jobTitle", e.target.value)} />
                    <img src={searchImg} onClick={() => search(pageSize, 1)} />
                </div>
                <Popover placement="topRight" trigger="click" open={popoverVisible}
                    onOpenChange={handleOpenChange} content={
                        <StudentSeeAllJobApplicationsSort isReset={isReset} onOpenChange={handleOpenChange2} />
                    }
                    getPopupContainer={() => document.getElementById('sortButton')}
                    >
                    <div className='websiteSysButton sortButton' id='sortButton'><img src={sortImg} />Sort</div>
                </Popover>
                <div className='websiteSysButton sortButton' onClick={reset}><img src={resetImg} />Reset</div>
            </div>
            <div className="sysTable" id="tableOne" style={{ marginTop: '20px' }}>
                <Table
                    scroll={{ x: 1200 }}
                    rowKey="jobApplId"
                    columns={columns} //列名
                    dataSource={tables} //数据
                    pagination={{  //分页
                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                        onChange: onChange,            //上页下页或者跳页方法
                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                        total: tablesCount,             //总共多少条数据
                        current: current,         //当前页
                        pageSize: pageSize,       //每页显示多少条数据
                        defaultCurrent: 1,                               //默认当前页为1
                        size: "small"
                    }}
                    onChange={handleTableChange}
                />
            </div>
        </div>
    )

}

export default StudentSeeAllJobApplications;